import { render, staticRenderFns } from "./card-project-select-proposal.vue?vue&type=template&id=420addaa&"
import script from "./card-project-select-proposal.vue?vue&type=script&lang=js&"
export * from "./card-project-select-proposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports